var _path, _path2, _path3, _path4, _path5, _ellipse, _ellipse2, _circle, _circle2, _circle3, _circle4, _rect, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _rect2, _path12, _path13, _path14, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChipMascot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 107,
    viewBox: "0 0 96 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.9503 96.3057C76.5292 96.3057 95.1149 96.8967 95.1154 100.909C95.1154 104.922 77.6222 106.758 56.0431 106.758C42.5097 106.758 30.5835 106.035 23.5714 104.507C21.9215 104.558 20.1749 104.585 18.3673 104.585C8.22397 104.585 0.000849462 103.788 0.00012207 102.046C0.00012207 100.339 7.40747 100.058 17.254 100.048C19.51 96.8101 35.0215 96.3057 54.9503 96.3057Z",
    fill: "black",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0537 99.9434H38.6533C37.0699 99.9433 36.4242 97.9073 37.7178 96.9941L40.7939 94.8223V84.3389H53.0537V99.9434Z",
    fill: "url(#paint0_linear_1468_7985)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0378 99.9434H70.2986V99.1699L70.3572 99.9434H73.4324C75.0157 99.9434 75.6623 97.9073 74.3689 96.9941L70.2986 94.1211V84.3389H58.0378V99.9434Z",
    fill: "url(#paint1_linear_1468_7985)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5923 20.2057L52.4591 20.0118L65.4035 20.4371C68.1364 20.5269 70.7523 21.5675 72.8001 23.3795L81.5923 31.1596C84.0377 33.3235 85.4717 36.4078 85.5501 39.6722L86.0246 59.4224L85.7663 72.3144C85.5769 81.7695 77.9552 89.3879 68.4999 89.5732L56.6408 89.8057L43.6451 89.5611C34.1664 89.3827 26.529 81.7345 26.3641 72.2556L26.0623 54.9087L26.365 37.5101C26.5296 28.052 34.135 20.4125 43.5923 20.2057Z",
    fill: "#00E4FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6825 20.2298C54.1617 22.7075 53.5985 24.921 51.9967 25.9359C49.5499 27.4859 45.6082 25.6524 43.193 21.84C42.8579 21.3111 42.5714 20.7707 42.3302 20.23L53.6825 20.2298Z",
    fill: "#03C9E1"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.9409,
    cy: 18.443,
    rx: 5.24462,
    ry: 8.17188,
    transform: "rotate(-21.5519 48.9409 18.443)",
    fill: "#00E4FF"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 58.2575,
    cy: 16.5541,
    rx: 5.81792,
    ry: 10.0492,
    transform: "rotate(10.0612 58.2575 16.5541)",
    fill: "#00E4FF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 47.5514,
    cy: 40.7832,
    r: 9.35203,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 47.5513,
    cy: 40.7831,
    r: 5.56091,
    fill: "#24565C"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 64.0271,
    cy: 40.7832,
    r: 9.35203,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 64.027,
    cy: 40.7831,
    r: 5.56091,
    fill: "#24565C"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 32.6177,
    y: 55.7852,
    width: 46.852,
    height: 27.5768,
    rx: 10.418,
    fill: "black",
    fillOpacity: 0.08
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3915 79.0086L55.3915 84.3394",
    stroke: "#00E4FF",
    strokeWidth: 0.868165
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4427 69.5737H79.0637",
    stroke: "#00E4FF",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4427 75.1196H79.0637",
    stroke: "#00E4FF",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4427 64.0278H79.0637",
    stroke: "#00E4FF",
    strokeWidth: 2
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7196 69.5737H48.3407",
    stroke: "#00E4FF",
    strokeWidth: 2
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7196 75.1196H48.3407",
    stroke: "#00E4FF",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7196 64.0278H48.3407",
    stroke: "#00E4FF",
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3915 54.8083L55.3915 83.3623",
    stroke: "#00E4FF",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 44.37,
    y: 63.248,
    width: 22.0426,
    height: 12.6511,
    rx: 4.74851,
    fill: "#00D1EB",
    stroke: "#00E4FF",
    strokeWidth: 2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3018 69.698C52.3034 69.0712 52.4861 68.459 52.8266 67.9386C53.1671 67.4183 53.6503 67.0132 54.215 66.7745C54.7798 66.5359 55.4008 66.4743 55.9996 66.5976C56.5984 66.721 57.1481 67.0237 57.5794 67.4675C58.0107 67.9114 58.3041 68.4764 58.4226 69.0913C58.5412 69.7062 58.4795 70.3433 58.2454 70.9223C58.0113 71.5012 57.6152 71.996 57.1073 72.344C56.5993 72.6921 56.0023 72.8778 55.3915 72.8778C54.571 72.8767 53.7844 72.541 53.205 71.9447C52.6255 71.3483 52.3006 70.5402 52.3018 69.698ZM53.4043 69.2498C53.4043 69.4018 53.4268 69.5529 53.471 69.698C53.4269 69.8431 53.4044 69.9942 53.4043 70.1462C53.4043 71.1262 54.3375 71.9234 55.4844 71.9234C55.8661 71.9191 56.2422 71.8288 56.586 71.6587C56.9652 71.4658 57.1739 71.2172 57.1739 70.9586C57.174 70.8124 57.1175 70.672 57.0168 70.5684C56.9162 70.4648 56.7796 70.4064 56.6371 70.4061C56.5339 70.4061 56.4398 70.4474 56.3309 70.4951C56.0659 70.621 55.7764 70.6834 55.4844 70.6776C54.7353 70.6776 54.0664 70.2778 53.8319 69.698C54.0664 69.1183 54.7353 68.7185 55.4844 68.7185C55.7764 68.7127 56.0659 68.775 56.3309 68.9009C56.4398 68.9488 56.5336 68.9899 56.6371 68.9899C56.7796 68.9896 56.9162 68.9312 57.0168 68.8276C57.1175 68.724 57.174 68.5837 57.1739 68.4374C57.1739 68.1789 56.965 67.9303 56.586 67.7374C56.2422 67.5673 55.8661 67.4768 55.4844 67.4725C54.3375 67.4726 53.4043 68.2699 53.4043 69.2498ZM53.7463 70.2266C53.884 70.4034 54.0503 70.5545 54.238 70.6734C54.6131 70.9083 55.0448 71.0307 55.4842 71.0267C55.8219 71.0328 56.1567 70.9609 56.4637 70.8164C56.5183 70.7878 56.5766 70.7672 56.6369 70.7554C56.6891 70.7561 56.739 70.7778 56.7759 70.8157C56.8128 70.8536 56.8338 70.9049 56.8344 70.9585C56.8344 71.1901 56.1805 71.574 55.4844 71.574C54.5574 71.574 53.7975 70.9768 53.7463 70.2266ZM55.4846 67.8219C56.1808 67.8219 56.8346 68.206 56.8346 68.4373C56.834 68.4909 56.813 68.5421 56.7762 68.58C56.7393 68.618 56.6895 68.6396 56.6373 68.6404C56.577 68.6286 56.5187 68.6081 56.4641 68.5794C56.157 68.435 55.8223 68.3632 55.4846 68.3691C55.0452 68.365 54.6136 68.4874 54.2386 68.7224C54.0509 68.8413 53.8845 68.9925 53.7468 69.1694C53.7979 68.4193 54.5578 67.8219 55.4846 67.8219Z",
    fill: "#00E4FF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M26.702 20.9153C27.0588 19.6064 28.9153 19.6064 29.2721 20.9153L30.6197 25.8594L35.5638 27.207C36.8727 27.5638 36.8727 29.4203 35.5638 29.7771L30.6197 31.1247L29.2721 36.0688C28.9153 37.3777 27.0588 37.3777 26.702 36.0688L25.3544 31.1247L20.4103 29.7771C19.1014 29.4203 19.1014 27.5638 20.4103 27.207L25.3544 25.8594L26.702 20.9153Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9843 52.2846C76.9843 54.8473 76.2244 57.3525 74.8006 59.4833C73.3768 61.6142 71.3531 63.275 68.9855 64.2557C66.6178 65.2364 64.0125 65.493 61.499 64.993C58.9855 64.4931 56.6767 63.259 54.8646 61.4469L57.6133 58.6982C58.8818 59.9667 60.4979 60.8305 62.2574 61.1805C64.0168 61.5305 65.8405 61.3508 67.4979 60.6643C69.1553 59.9778 70.5718 58.8153 71.5685 57.3237C72.5651 55.8321 73.0971 54.0785 73.0971 52.2846H76.9843Z",
    fill: "#24565C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1468_7985",
    x1: 45.0407,
    y1: 84.3389,
    x2: 45.0407,
    y2: 99.9434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.447015,
    stopColor: "#00B4CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447115,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1468_7985",
    x1: 66.5482,
    y1: 84.3389,
    x2: 66.5482,
    y2: 99.9434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.447015,
    stopColor: "#00B4CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447115,
    stopColor: "#00E3FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChipMascot);
export default __webpack_public_path__ + "static/media/chipMascot.1000ac9191141f68a59fdf81344a0154.svg";
export { ForwardRef as ReactComponent };